type GsapBundle = {
  gsap: typeof import('gsap').default
  ScrollTrigger: typeof import('gsap/ScrollTrigger').ScrollTrigger
  SplitText: typeof import('gsap/SplitText').SplitText
  GSDevTools: typeof import('gsap/GSDevTools').GSDevTools
  
  ScrollToPlugin: typeof import('gsap/ScrollToPlugin').ScrollToPlugin
}

let gsapPromise: Promise<GsapBundle> | null = null

export const loadGsap = async (): Promise<GsapBundle> => {
  if (!gsapPromise) {
    gsapPromise = (async () => {
      const [
        gsapModule,
        scrollTriggerModule,
        splitTextModule,
        gsDevToolsModule,
        
        scrollToPluginModule
      ] = await Promise.all([
        import('gsap'),
        import('gsap/ScrollTrigger'),
        import('gsap/SplitText'),
        import('gsap/GSDevTools'),
        
        import('gsap/ScrollToPlugin')
      ])

      const gsap = gsapModule.default
      const ScrollTrigger = scrollTriggerModule.ScrollTrigger
      const SplitText = splitTextModule.SplitText
      const GSDevTools = gsDevToolsModule.GSDevTools
      
      const ScrollToPlugin = scrollToPluginModule.ScrollToPlugin

      gsap.registerPlugin(
        ScrollTrigger,
        SplitText,
        GSDevTools,
        
        ScrollToPlugin
      )

      return {
        gsap,
        ScrollTrigger,
        SplitText,
        GSDevTools,
        ScrollToPlugin
      }
    })()
  }

  return gsapPromise
}
